module.exports = __webpack_public_path__ + "img/oredoo-palestine.4eea5577.png";